import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

export const scaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    scaffolderPlugin.getExtension('page:scaffolder').override({
      params: {
        title: 'Volkswagen Software Templates',
      },
    }),
  ],
});
